import { isEmpty } from 'lodash';
// import criticalIcon from '@root/assets/svg/Compliance_V1/Critical.svg';
// import highIcon from '@root/assets/svg/Compliance_V1/High.svg';
// import mediumIcon from '@root/assets/svg/Compliance_V1/Medium.svg';
// import lowIcon from '@root/assets/svg/Compliance_V1/Low.svg';
import info_icon from '@root/assets/svg/icons/info_icon.svg';
import warning_icon from '@root/assets/svg/icons/warning_icon.svg';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
// import CriticalIcon from '@root/components/svg/criticalIcon';
// import HighIcon from '@root/components/svg/high';
// import MediumIcon from '@root/components/svg/mediumIcon';
// import LowIcon from '@root/components/svg/lowIcon';
import criticalIcon2 from '@assets/svg/New_Severity_Icons/Critical.svg';
import highIcon2 from '@assets/svg/New_Severity_Icons/High.svg';
import lowIcon2 from '@assets/svg/New_Severity_Icons/Low.svg';
import mediumIcon2 from '@assets/svg/New_Severity_Icons/Medium.svg';
import warning from '@assets/svg/New_Severity_Icons/warning_severity.svg';
import info from '@assets/svg/workload/info.svg';
// import Text from '@root/components/v2/ui-elements/Text';
import { capitalizeFirstLetter } from '@root/utilities/string';

const severityColorMapper = {
  all: '#405877',
  critical: '#FF0000',
  high: '#EB5757',
  medium: '#F2994A',
  low: '#F2C94C',
};
export const severityDarkColors = {
  CRITICAL: '#E90362', // Brighter Pastel Pink
  HIGH: '#F2583C', // Brighter Pastel Orange
  MEDIUM: '#FF8710', // Brighter Pastel Yellow
  LOW: '#FED237', // Pastel Green
  ALL: '#9FD4FF', // Brighter Pastel Blue
  DEFAULT: '#F8BBD9', // Very light pastel pink
};

export const severityLightColors = {
  CRITICAL: '#F9C2D3', // Very light pastel pink background
  HIGH: '#FDC2B8', // Very light pastel orange background
  MEDIUM: '#FFD9B3', // Very light pastel yellow background
  LOW: '#FFF1B8', // Very light pastel green background
  ALL: '#E6F2FF', // Very light pastel blue background
  DEFAULT: '#FFF0F8', // Very light pastel pink background
};

export const SeverityWithText = ({ propsValue, alignItems = 'center' }) => {
  if (!isEmpty(propsValue)) {
    if (propsValue.toUpperCase()?.includes('HIGH')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="High" isIcon={false}>
            {/* <HighIcon width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}

            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img width={'20px'} src={highIcon2} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue.toUpperCase()?.includes('MEDIUM')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Medium" isIcon={false}>
            {/* <MediumIcon height={height} width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}
            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img width={'20px'} src={mediumIcon2} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue.toUpperCase().includes('LOW')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Low" isIcon={false}>
            {/* <LowIcon textDisabled={true} width={'88px'} horizontalPosition="flex-start" /> */}
            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img width={'20px'} src={lowIcon2} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue.toUpperCase().includes('CRITICAL')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Critical" isIcon={false}>
            {/* <CriticalIcon width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}
            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img width={'20px'} src={criticalIcon2} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue.toUpperCase().includes('WARNING')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Warning" isIcon={false}>
            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img src={warning} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue.toUpperCase().includes('INFO')) {
      return (
        <span
          style={{
            display: 'inline-flex',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Info" isIcon={false}>
            <span style={{ display: 'inline-flex', alignItems: alignItems, gap: '8px' }}>
              <img src={info} style={{ height: '22px', width: '22px' }} />
              <span style={{ fontSize: '13px', fontFamily: 'Manrope', lineHeight: '20px' }}>
                {' '}
                {capitalizeFirstLetter(propsValue)}
              </span>
            </span>
          </Tooltip>
        </span>
      );
    } else if (propsValue === 'non-compliant') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#F62121', color: 'white', width: '100px', height: '18px' }}>
            Non-Compliant
          </span>
        </div>
      );
    } else if (propsValue === 'compliant') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#03BB34', color: 'white', width: '100px', height: '18px' }}>
            Compliant
          </span>
        </div>
      );
    } else if (propsValue === 'not-applicable') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#7657CC', color: 'white', width: '100px', height: '18px' }}>
            Not-Applicable
          </span>
        </div>
      );
    } else {
      return propsValue;
    }
  } else return '-';
};

export const SeverityBadge = ({ propsValue, height }) => {
  if (!isEmpty(propsValue)) {
    if (propsValue.toUpperCase().includes('HIGH')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="High" isIcon={false}>
            {/* <HighIcon width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}
            <img width={'20px'} src={highIcon2} />
          </Tooltip>
        </div>
      );
    } else if (propsValue.toUpperCase().includes('MEDIUM')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Medium" isIcon={false}>
            {/* <MediumIcon height={height} width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}
            <img src={mediumIcon2} style={{ height: height, width: '20px' }} />
          </Tooltip>
        </div>
      );
    } else if (propsValue.toUpperCase().includes('LOW')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Low" isIcon={false}>
            {/* <LowIcon textDisabled={true} width={'88px'} horizontalPosition="flex-start" /> */}
            <img width={'20px'} src={lowIcon2} />
          </Tooltip>
        </div>
      );
    } else if (propsValue.toUpperCase().includes('CRITICAL')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Critical" isIcon={false}>
            {/* <CriticalIcon width={'88px'} textDisabled={true} horizontalPosition="flex-start" /> */}
            <img width={'20px'} src={criticalIcon2} />
          </Tooltip>
        </div>
      );
    } else if (propsValue.toUpperCase().includes('WARNING')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Warning" isIcon={false}>
            <img src={warning_icon} style={{ width: '88px' }} />
          </Tooltip>
        </div>
      );
    } else if (propsValue.toUpperCase().includes('INFO')) {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <Tooltip title="Info" isIcon={false}>
            <img src={info_icon} />
          </Tooltip>
        </div>
      );
    } else if (propsValue === 'non-compliant') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#F62121', color: 'white', width: '100px', height: '18px' }}>
            Non-Compliant
          </span>
        </div>
      );
    } else if (propsValue === 'compliant') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#03BB34', color: 'white', width: '100px', height: '18px' }}>
            Compliant
          </span>
        </div>
      );
    } else if (propsValue === 'not-applicable') {
      return (
        <div
          className="text-center"
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
          }}>
          <span className="badge" style={{ background: '#7657CC', color: 'white', width: '100px', height: '18px' }}>
            Not-Applicable
          </span>
        </div>
      );
    } else {
      return propsValue;
    }
  } else return null;
};
export const SeverityLablel = ({ propsValue }) => {
  if (!isEmpty(propsValue)) {
    return (
      <p
        className="m-0"
        style={{
          fontSize: '11px',
          color: '#fff',
          fontWeight: '400',
          lineHeight: 2,
          textAlign: 'center',
          borderRadius: '5px',
          background: severityColorMapper[propsValue.toLowerCase()],
        }}>
        {capitalizeFirstLetter(propsValue)}{' '}
      </p>
    );
  } else return null;
};
